import * as React from "react";
import styled from "styled-components";
import { CompanyType, VismaArticle } from ".";

interface Props {
  articles: VismaArticle[];
  companyTypes: CompanyType[];
  companyTypeMap: Map<string, CompanyType>;
  onCompanyTypeChanged?: (
    article: VismaArticle,
    companyType: CompanyType
  ) => void;
}

const Table = styled.table`
  // Use all available width in all columns except the first one
  & thead tr {
    & > *:nth-child(1) {
      width: 150px;
    }
  }

  // Right align text in the first column
  & > * > tr > * {
    &:nth-child(1) {
      text-align: right;
      font-weight: bold;
      white-space: pre-wrap;
    }
  }
`;

const CompanyTypeDropdown = ({
  articleNo,
  companyTypes,
  companyTypeMap,
  onChange,
}: {
  articleNo: string;
  companyTypes: CompanyType[];
  companyTypeMap: Map<string, CompanyType>;
  onChange?: (companyType: CompanyType) => void;
}) => {
  const _onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    let intValue = parseInt(event.target.value);
    const companyType = companyTypes.find(
      (companyType) => companyType.companyTypeId === intValue
    );
    if (companyType && onChange) {
      onChange(companyType);
    }
  };

  return (
    <select
      value={companyTypeMap.get(articleNo)?.companyTypeId}
      onChange={_onChange}
    >
      {companyTypes.map((companyType) => (
        <option
          key={companyType.companyTypeId}
          value={companyType.companyTypeId}
        >
          {companyType.name}
        </option>
      ))}
    </select>
  );
};

const ArticleList = ({
  articles,
  companyTypes,
  companyTypeMap,
  onCompanyTypeChanged,
}: Props) => {
  return (
    <div>
      {!articles.length && <p>Inga nya artiklar hittades.</p>}
      {articles.map((article) => (
        <div key={article.articleNo}>
          <h4>
            {article.articleNo} - {article.name}
          </h4>
          <Table className="table-small dataTable dtr-inline">
            <thead>
              <tr>
                <th>Fält</th>
                <th>Värde</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Artikelnr</td>
                <td>{article.articleNo}</td>
              </tr>
              <tr>
                <td>Artikelgrupp</td>
                <td>{article.articleGroup}</td>
              </tr>
              <tr>
                <td>Namn</td>
                <td>{article.name}</td>
              </tr>
              <tr>
                <td>Enhet</td>
                <td>{article.unit}</td>
              </tr>
              <tr>
                <td>Pris</td>
                <td>{article.price}</td>
              </tr>
              <tr>
                <td>Företagstyp</td>
                <td>
                  <CompanyTypeDropdown
                    articleNo={article.articleNo}
                    companyTypes={companyTypes}
                    companyTypeMap={companyTypeMap}
                    onChange={(id) =>
                      onCompanyTypeChanged && onCompanyTypeChanged(article, id)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      ))}
    </div>
  );
};

export default ArticleList;
